<template>
  <div class="viewer-metadata">
    <ul v-if="metadata">
      <div class="viewer-metadata__header">
        <h2>Metadata</h2>
      </div>
      <div class="viewer-metadata__contents">
        <li v-for="item in metadata">
          <strong>{{ item.label }}</strong>:
          <span>{{ item.value }}</span>
        </li>
      </div>
    </ul>
    <h4 v-else>This object has no metadata to display</h4>
  </div>
</template>

<script>
export default {
  name: 'viewerMetadata',
  props: ['metadata']
}

</script>

<style lang="scss" scoped>
.viewer-metadata {
  padding: 1rem;
  color: #ccc;

  h1, h2, h3, h4, h5, h6, strong, {
    color: #fff;
  }

  li {
    margin-bottom: 1em;
  }

  &__contents {
    word-wrap: break-word;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/viewer/Metadata.vue?5e6a2290